import { BasicMetadata, BroIdMetadata, EditMetadata } from "./MetaData";
import { Task } from "./Task";

export const frdEvaluationProcedureOptions = [
  {
    value: "QCProtocolFormatieweerstandonderzoek2021",
    label: "QC-Protocol Formatieweerstandsonderzoek 2021",
  },
  {
    value: "oordeelDeskundige",
    label: "Oordeel deskundig",
  },
  {
    value: "vergelijkVoorgaandeMetingen",
    label: "Vergelijking met voorgaande metingen",
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
] as const;

export type FrdEvaluationProcedureOptions = (typeof frdEvaluationProcedureOptions)[number]["value"];

export const frdDeterminationProcedureOptions = [
  {
    value: "geen",
    label: "Geen",
  },
  {
    value: "werkinstructieWaternet",
    label: "Werkinstructie Waternet",
  },
  {
    value: "manualOpnameZoutwachterOasen",
    label: "Handboek Opname Zoutwachter Oasen",
  },
  {
    value: "onbekend",
    label: "Onbekend",
    onlyImbroA: true,
  },
] as const;

export type FrdDeterminationProcedureOptions =
  (typeof frdDeterminationProcedureOptions)[number]["value"];

export interface FRDStartRegistrationData {
  objectIdAccountableParty: string;
  gmwBroId: string;
  tubeNumber: string;
  groundwaterMonitoringNets: string[];
}

export interface MeasurementConfiguration {
  measurementConfigurationId: string; // Unique identifier for the measurement configuration
  measurementE1CableNumber: number; // Cable number for electrode 1
  measurementE1ElectrodeNumber: number; // Electrode number for electrode 1
  measurementE2CableNumber: number; // Cable number for electrode 2
  measurementE2ElectrodeNumber: number; // Electrode number for electrode 2
  currentE1CableNumber: number; // Cable number for electrode 1 in current measurement
  currentE1ElectrodeNumber: number; // Electrode number for electrode 1 in
  currentE2CableNumber: number; // Cable number for electrode 2 in current measurement
  currentE2ElectrodeNumber: number; // Electrode number for electrode 2 in current measurement
}

export interface FRDMeasurementConfigData {
  measurementConfigurations: MeasurementConfiguration[]; // Not actually used / required for message
}

export interface RelatedCalculatedApparentFormationResistance {
  calculationOperatorKvk?: string; // Kvk number of the calculation operator, max 8 characters
  evaluationProcedure?: string; // EvaluatieProcedure
  elementCount: number; // Number of values in 'values'
  values: string; // The calculated value in ohm.m
}

export interface GEMMeasurement {
  value: number;
  unit: string;
  configuration: string;
}

export interface FRDMeasurementData {
  measurementDate: string; // Date of the measurement
  measurementOperatorKvk: string; // Kvk number of the measurement operator, max 8 characters
  determinationProcedure: string; // DeterminationProcedure
  evaluationProcedure: string; // EvaluatieProcedure
  measurements: GEMMeasurement[]; // Measurements list
  relatedCalculatedApparentFormationResistance: RelatedCalculatedApparentFormationResistance;
}

export type FRDStartRegistrationTask = Task<FRDStartRegistrationData, BasicMetadata>;
export type EditFRDStartRegistrationTask = Task<FRDStartRegistrationData, EditMetadata>;

export interface SendFRDMeasurementConfigTask
  extends Task<FRDMeasurementConfigData, BroIdMetadata> {
  measurementConfigFile: Blob;
}

export type FRDMeasurementConfigTask = Omit<SendFRDMeasurementConfigTask, "sourcedocumentData">;

export interface SendEditFRDMeasurementConfigTask
  extends Task<FRDMeasurementConfigData, EditMetadata> {
  measurementConfigFile: Blob;
}

export type EditFRDMeasurementConfigTask = Omit<
  SendEditFRDMeasurementConfigTask,
  "sourcedocumentData"
>;

export interface SendFRDMeasurementTask extends Task<FRDMeasurementData, BroIdMetadata> {
  measurementFile: Blob;
}

export type FRDMeasurementTask = Omit<SendFRDMeasurementTask, "sourcedocumentData"> & {
  sourcedocumentData: Omit<
    FRDMeasurementData,
    "measurements" | "relatedCalculatedApparentFormationResistance"
  >;
};

export interface SendEditFRDMeasurementTask extends Task<FRDMeasurementData, EditMetadata> {
  measurementFile: Blob;
}

export type EditFRDMeasurementTask = Omit<SendEditFRDMeasurementTask, "sourcedocumentData"> & {
  sourcedocumentData: Omit<
    FRDMeasurementData,
    "measurements" | "relatedCalculatedApparentFormationResistance"
  >;
};

export type FRDClosureTask = { metadata: BroIdMetadata };
